import { createSelector } from "reselect";
import { assessmentVersionSelector } from "src/selectors/config_selectors";

export const treatmentColumnEnabledSelector = createSelector(
  assessmentVersionSelector,
  version => version == "ML1"
);
